// Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Injectable } from '@angular/core';
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialog} from '@angular/material/dialog';
import {AlertDialogComponent} from '../app/dialogs/alert/alert.component';
import {CustomSnackBarComponent, ICustomSnackBarConfig} from '../app/shared/components/custom-snack-bar/custom-snack-bar.component';
import { TranslateService } from '@ngx-translate/core';
import * as Sentry from '@sentry/browser';

@Injectable({providedIn: 'root'})
export class NotificationService {
  previousMessage: string = null;

  constructor(
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    private translate: TranslateService
  ) { }

  open(message: string, duration: number) {

    this.translate.get(['COPY_DISMISS']).subscribe(vals => {
        const config: ICustomSnackBarConfig = {
          message: message,
          action: vals['COPY_DISMISS']
        }
        this.snackBar.openFromComponent(CustomSnackBarComponent, {
          duration: duration,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          data: config,
        });
      });
  }

  showSuccess(message: string): void {
    this.open(message, 5000);
  }

  showUpdate(message: string): void {
    this.open(message, 3000);
  }

  show(message: string): void {
    this.open(message, 8000);
  }

  showError(message: string, title = ''): void {
    let sentryMessage = '';
    if (!!title) {
      sentryMessage = title + ": ";
    }
    Sentry.captureMessage(`${sentryMessage}${message}`);
    this.translate.get(['COPY_DISMISS', 'ERROR_ENCOUNTERED']).subscribe(vals => {
      if (title === '') {
        title = vals['ERROR_ENCOUNTERED'];
      }
      if (message === this.previousMessage) {
        return;  // Don't stack dialogs for the same message
      }
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        width: '450px',
        data: {
          title: title,
          content: message,
          acceptBtnName: vals['COPY_DISMISS'],
          showRejectBtn: false,
        },
      });
      dialogRef.afterClosed().subscribe(result => {
        this.previousMessage = null;
      });
      this.previousMessage = message;
    });
  }

  showWarning(message: string): void {
    this.translate.get(['PF_EWARNING']).subscribe(vals => {
      this.showError(message, vals['PF_EWARNING']);
    });
  }

  dismiss(): void {
    this.snackBar.dismiss();
  }
}
